console.info("TD Snap for Schools Form v0.1");
if (typeof app === "undefined") {
  var app = {
    private: {
      getCaseValues: function () {
        let ca = {
          Subject: document.getElementById("subject").value,
          RecordTypeId: document.getElementById("recordTypeId").value,
          Origin: document.getElementById("origin").value,
          Status: document.getElementById("status").value,
        };

        return JSON.stringify(ca);
      },
    },
    helper: {},
    changeHandler: {},
    doSubmit: function (e) {
        const submitBtn = e.target.querySelector('button[type="submit"], input[type="submit"]');
      document.getElementById("case_values").value =app.private.getCaseValues();
      document.getElementById("case_description").value =TDForm.helper.getDescriptionFromIds();

        if (submitBtn) submitBtn.disabled = true;
      return true;
    },
  };
}
